import React from 'react'
import PropTypes from 'prop-types'
import { FlowRequestModalFooter, FlowRequestModalText } from './style'
import Button from '../Button'
import { FormattedMessage } from 'react-intl'

const FlowRequestModal = ({ confirmHandler, cancelHandler, text, confirmBtnText, item, approve, rejectBtnText = 'cancel' }) => {

  const confirmOnClick = () => {
    confirmHandler(item, { isApproved: approve })
  }

  return (
    <>
      <FlowRequestModalText data-testid='test-request-modal-text'>
        {text}
      </FlowRequestModalText>
      <FlowRequestModalFooter>
        <Button onClick={cancelHandler} type='secondary' dataTest='cancel'>
          <FormattedMessage id={rejectBtnText} />
        </Button>
        <Button onClick={confirmOnClick} type={approve ? 'primary' : 'destructive'} dataTest='confirm'>
          <FormattedMessage id={confirmBtnText} />
        </Button>
      </FlowRequestModalFooter>
    </>
  )
}

FlowRequestModal.propTypes = {
  confirmHandler: PropTypes.func.isRequired,
  cancelHandler: PropTypes.func.isRequired,
  text: PropTypes.node.isRequired,
  confirmBtnText: PropTypes.string.isRequired,
  item: PropTypes.any,
  approve: PropTypes.bool.isRequired,
  rejectBtnText: PropTypes.string
}

export default FlowRequestModal
